export default __webpack_public_path__ + "static/media/CarImages.KigerGallery4.4aacc605.jpg";